import React from "react"
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export default function MenuButton({ title, selected, onClick }) {
    return (
        <ListItemButton
            selected={selected}
            onClick={() => onClick()}
        >
            <ListItemText primary={title} />
            <ChevronRightIcon />
        </ListItemButton>
    )
}
